import React from 'react'

const LinkedInLogo = () => {
  return (
    <div className="linkedin_logo">
      <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="15px" viewBox="0 0 16 15" version="1.1">
        <title>iconmonstr-linkedin-1</title>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="iconmonstr-linkedin-1" fill="#FFFFFF" fill-rule="nonzero">
            <path
              d="M3.32,1.63043478 C3.32,2.53108696 2.58,3.26086957 1.66666667,3.26086957 C0.753333333,3.26086957 0.0133333333,2.53108696 0.0133333333,1.63043478 C0.0133333333,0.730434783 0.753333333,0 1.66666667,0 C2.58,0 3.32,0.730434783 3.32,1.63043478 Z M3.33333333,4.56521739 L0,4.56521739 L0,15 L3.33333333,15 L3.33333333,4.56521739 Z M8.65466667,4.56521739 L5.34266667,4.56521739 L5.34266667,15 L8.65533333,15 L8.65533333,9.5223913 C8.65533333,6.47673913 12.6746667,6.2276087 12.6746667,9.5223913 L12.6746667,15 L16,15 L16,8.39282609 C16,3.25369565 10.052,3.44086957 8.65466667,5.97065217 L8.65466667,4.56521739 Z"
              id="Shape"
            />
          </g>
        </g>
      </svg>
    </div>
  )
}

export default LinkedInLogo
